import { Component, EventEmitter, Input, Output } from '@angular/core';

// Shared labelled toggle row (label + optional help on the left, switch on the right).
@Component({
  selector: 'omp-toggle',
  templateUrl: './omp-toggle.component.html',
  styleUrls: ['./omp-controls.scss'],
})
export class OmpToggleComponent {
  @Input() value: boolean;
  @Input() label: string;
  @Input() help: string;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<boolean>();
}
